/* Serene shared behavior (U1 foundation).
   Home-relevant behavior only:
   - .reveal -> .visible via IntersectionObserver
   - Standards mobile accordion via button[data-standard-toggle] (<=720px)
   Re-init safe: binds per-element with data-serene-bound, so
   shopify:section:load re-binds freshly rendered DOM without doubling. */
(function () {
  'use strict';
  // D12 (28 Sep 2026): each Serene section includes this file, so it ran up to 9 times per page. Run once.
  if (window.huxSereneLoaded) return;
  window.huxSereneLoaded = true;

  var revealObserver = null;

  function getRevealObserver() {
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
    }
    return revealObserver;
  }

  function initReveals(root) {
    // In the theme editor, or without IntersectionObserver, never leave
    // bands at opacity 0 — show everything immediately.
    var showImmediately =
      (window.Shopify && window.Shopify.designMode) ||
      !('IntersectionObserver' in window);
    var nodes = root.querySelectorAll('.serene-section .reveal');
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.hasAttribute('data-serene-bound')) return;
      el.setAttribute('data-serene-bound', '');
      if (showImmediately) {
        el.classList.add('visible');
      } else {
        getRevealObserver().observe(el);
      }
    });
  }

  function initStandardToggles(root) {
    var buttons = root.querySelectorAll('.serene-section button[data-standard-toggle]');
    Array.prototype.forEach.call(buttons, function (button) {
      if (button.hasAttribute('data-serene-bound')) return;
      button.setAttribute('data-serene-bound', '');
      button.addEventListener('click', function () {
        // Accordion behavior is mobile-only, matching the mock.
        if (!window.matchMedia('(max-width: 720px)').matches) return;
        var story = button.closest('.standard-story');
        if (!story) return;
        var open = story.classList.toggle('open');
        button.setAttribute('aria-expanded', String(open));
      });
    });
  }

  function initCollectionChips(root) {
    var shells = root.querySelectorAll('.serene-section .collection-chips-shell');
    Array.prototype.forEach.call(shells, function (shell) {
      if (shell.hasAttribute('data-serene-bound')) return;
      shell.setAttribute('data-serene-bound', '');
      var nav = shell.querySelector('.collection-chips');
      if (!nav) return;
      var chips = nav.querySelectorAll('.collection-chip');
      var pairs = [];
      var activeChip = null;
      var ticking = false;

      Array.prototype.forEach.call(chips, function (chip) {
        var target = document.querySelector(chip.getAttribute('href'));
        if (target) pairs.push({ chip: chip, target: target });
      });

      function updateSticky() {
        if (!window.matchMedia('(max-width: 720px)').matches) {
          shell.classList.remove('stuck');
          shell.style.minHeight = '';
          return;
        }

        if (shell.getBoundingClientRect().top < 40) {
          shell.classList.add('stuck');
          shell.style.minHeight = nav.getBoundingClientRect().height + 'px';
        } else {
          shell.classList.remove('stuck');
          shell.style.minHeight = '';
        }
      }

      function updateActive() {
        var nextActive = null;

        pairs.forEach(function (pair) {
          if (pair.target.getBoundingClientRect().top <= 120) nextActive = pair.chip;
        });

        if (nextActive === activeChip) return;
        activeChip = nextActive;
        Array.prototype.forEach.call(chips, function (chip) {
          chip.classList.toggle('active', chip === activeChip);
        });

        if (activeChip && nav.scrollWidth > nav.clientWidth) {
          nav.scrollTo({
            left: activeChip.offsetLeft - 16,
            behavior: 'smooth'
          });
        }
      }

      function updateChevron() {
        shell.classList.toggle(
          'at-end',
          nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 4
        );
      }

      function update() {
        ticking = false;
        updateSticky();
        updateActive();
        updateChevron();
      }

      function requestUpdate() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }

      window.addEventListener('scroll', requestUpdate, { passive: true });
      nav.addEventListener('scroll', requestUpdate, { passive: true });
      update();
    });
  }

  function initJournalCopy(root) {
    var buttons = root.querySelectorAll('.serene-section button[data-journal-copy]');
    Array.prototype.forEach.call(buttons, function (button) {
      if (button.hasAttribute('data-serene-bound')) return;
      button.setAttribute('data-serene-bound', '');
      button.addEventListener('click', function () {
        var status = button.parentElement && button.parentElement.querySelector('[data-journal-copy-status]');
        if (!navigator.clipboard || !navigator.clipboard.writeText) {
          if (status) status.textContent = 'Copy the address from your browser.';
          return;
        }
        navigator.clipboard.writeText(window.location.href).then(function () {
          if (status) status.textContent = 'Link copied.';
        }).catch(function () {
          if (status) status.textContent = 'Copy the address from your browser.';
        });
      });
    });
  }

  function initJournalToc(root) {
    if (!('IntersectionObserver' in window)) return;
    var navs = root.querySelectorAll('.serene-section .journal-article-toc');
    Array.prototype.forEach.call(navs, function (nav) {
      if (nav.hasAttribute('data-serene-bound')) return;
      nav.setAttribute('data-serene-bound', '');
      var links = nav.querySelectorAll('a[href^="#"]');
      var targets = [];
      Array.prototype.forEach.call(links, function (link) {
        var id = link.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (target) targets.push({ link: link, target: target });
      });
      if (!targets.length) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          targets.forEach(function (item) {
            item.link.classList.toggle('active', item.target === entry.target);
          });
        });
      }, { rootMargin: '-18% 0px -70% 0px', threshold: 0 });
      targets.forEach(function (item) { observer.observe(item.target); });
    });
  }

  function money(cents, format) {
    var roundedCents = Math.round(Number(cents) || 0);
    var amount = (roundedCents / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0];
    var decimal = parts[1];
    var formatted = '';
    var index;

    for (index = 0; index < whole.length; index += 1) {
      if (index > 0 && (whole.length - index) % 3 === 0) formatted += ',';
      formatted += whole.charAt(index);
    }
    if (decimal !== '00') formatted += '.' + decimal;

    return (format || 'Dhs. {{amount}}').replace(/{{\s*amount\s*}}/, formatted);
  }

  function initBuybox(root) {
    var boxes = root.querySelectorAll('[data-buybox-root]');

    Array.prototype.forEach.call(boxes, function (box) {
      var jsonNode;
      var config;
      var variants;
      var moneyFormat;
      var firmnessOptions;
      var hasFirmness;
      var selectedFirmness;
      var selectedSizeOption;
      var nativeSize;
      var sizeTrigger;
      var sizeList;
      var sizeGroup;
      var sizeOptions;
      var masterId;
      var priceCurrent;
      var priceCompare;
      var priceSave;
      var sizeValue;
      var sizePrices;
      var atc;
      var atcTotal;
      var tabby;
      var tamara;
      var announcement;
      var bundle;
      var bundleToggle;
      var bundlePriceCents;
      var form;
      var state;
      var currentVariant;
      var inFlight = false;
      var errorTimer = null;

      if (box.hasAttribute('data-serene-bound')) return;
      box.setAttribute('data-serene-bound', '');

      jsonNode = box.querySelector('[data-buybox-variants]');
      if (!jsonNode) return;

      try {
        config = JSON.parse(jsonNode.textContent);
      } catch (error) {
        return;
      }

      variants = config.variants || [];
      if (!variants.length) return;

      moneyFormat = config.money_format || 'Dhs. {{amount}}';
      firmnessOptions = box.querySelectorAll('[data-buybox-firmness-option]');
      hasFirmness = firmnessOptions.length > 0;
      selectedFirmness = box.querySelector('[data-buybox-firmness-option]:checked');
      selectedSizeOption = box.querySelector('[data-buybox-size-option][aria-selected="true"]');
      nativeSize = box.querySelector('[data-buybox-native-size]');
      sizeTrigger = box.querySelector('[data-buybox-size-trigger]');
      sizeList = box.querySelector('[data-buybox-size-list]');
      sizeGroup = box.querySelector('[data-buybox-size]');
      sizeOptions = box.querySelectorAll('[data-buybox-size-option]');
      masterId = box.querySelector('[data-buybox-master-id]');
      priceCurrent = box.querySelector('[data-buybox-current-price]');
      priceCompare = box.querySelector('[data-buybox-compare-price]');
      priceSave = box.querySelector('[data-buybox-save]');
      sizeValue = box.querySelector('[data-buybox-size-value]');
      sizePrices = box.querySelector('[data-buybox-size-prices]');
      atc = box.querySelector('[data-buybox-atc]');
      atcTotal = box.querySelector('[data-buybox-atc-total]');
      tabby = box.querySelector('[data-buybox-tabby]');
      tamara = box.querySelector('[data-buybox-tamara]');
      announcement = box.querySelector('[data-buybox-price-announcement]');
      bundle = box.querySelector('[data-buybox-bundle]');
      bundleToggle = box.querySelector('[data-buybox-bundle-toggle]');
      bundlePriceCents = bundle ? parseInt(bundle.getAttribute('data-bundle-price-cents'), 10) || 0 : 0;
      form = box.querySelector('[data-buybox-form]') || box.querySelector('form[action*="/cart/add"]');

      state = {
        size: selectedSizeOption ? selectedSizeOption.getAttribute('data-value') : (nativeSize ? nativeSize.value : variants[0].size),
        firmness: selectedFirmness ? selectedFirmness.value : ''
      };

      function bindOnce(element, bind) {
        if (!element || element.hasAttribute('data-serene-bound')) return;
        element.setAttribute('data-serene-bound', '');
        bind(element);
      }

      function resolve(size, firmness) {
        var fallback = null;
        var exact = null;

        Array.prototype.forEach.call(variants, function (variant) {
          if (variant.size !== size) return;
          if (!fallback) fallback = variant;
          if (!exact && (!hasFirmness || variant.firmness === firmness)) exact = variant;
        });

        return exact || fallback;
      }

      function rebuildPrices(container, variant) {
        var compare;
        var current;

        if (!container || !variant) return;
        while (container.firstChild) container.removeChild(container.firstChild);

        if (variant.compare_cents && variant.compare_cents > variant.price_cents) {
          compare = document.createElement('s');
          compare.className = 'buybox-size-compare';
          compare.textContent = money(variant.compare_cents, moneyFormat);
          container.appendChild(compare);
        }

        current = document.createElement('strong');
        current.className = 'buybox-size-price';
        current.textContent = money(variant.price_cents, moneyFormat);
        container.appendChild(current);
      }

      function setUnavailableStyle(option, unavailable) {
        if (unavailable) {
          option.classList.add('buybox-is-disabled');
          option.setAttribute('aria-disabled', 'true');
          option.style.opacity = '0.45';
          option.style.cursor = 'not-allowed';
        } else {
          option.classList.remove('buybox-is-disabled');
          option.setAttribute('aria-disabled', 'false');
          option.style.opacity = '';
          option.style.cursor = '';
        }
      }

      function updateSizeOptions() {
        Array.prototype.forEach.call(sizeOptions, function (option) {
          var value = option.getAttribute('data-value');
          var optionVariant = resolve(value, state.firmness);
          var selected = value === state.size;
          var unavailable = !optionVariant || !optionVariant.available;

          option.setAttribute('aria-selected', selected ? 'true' : 'false');
          option.classList.toggle('buybox-is-selected', selected);
          option.setAttribute('tabindex', selected ? '0' : '-1');
          setUnavailableStyle(option, unavailable);
        });

        if (nativeSize) {
          nativeSize.value = state.size;
          Array.prototype.forEach.call(nativeSize.options, function (option) {
            var optionVariant = resolve(option.value, state.firmness);
            option.disabled = !optionVariant || !optionVariant.available;
          });
        }
      }

      function updateFirmnessOptions() {
        Array.prototype.forEach.call(firmnessOptions, function (radio) {
          var cell = radio.closest('.buybox-segment-cell');
          var selected = radio.value === state.firmness;
          radio.checked = selected;
          if (cell) cell.classList.toggle('buybox-is-selected', selected);
        });
      }

      function updatePriceLine(variant) {
        var hasSaving = variant.compare_cents && variant.compare_cents > variant.price_cents;
        var saving;

        if (priceCurrent) priceCurrent.textContent = money(variant.price_cents, moneyFormat);
        if (priceCompare) {
          priceCompare.hidden = !hasSaving;
          priceCompare.textContent = hasSaving ? money(variant.compare_cents, moneyFormat) : '';
        }
        if (priceSave) {
          saving = hasSaving ? Math.round((variant.compare_cents - variant.price_cents) / variant.compare_cents * 100) : 0;
          priceSave.hidden = !hasSaving;
          priceSave.textContent = hasSaving ? 'SAVE ' + saving + '%' : '';
        }
      }

      function updateAtcTotal(variant) {
        var total = variant.price_cents;
        if (bundleToggle && bundleToggle.checked) total += bundlePriceCents;
        if (atcTotal) atcTotal.textContent = '\u2014 ' + money(total, moneyFormat);
      }

      function updatePayments(variant) {
        var tabbyAmount = Math.round(variant.price_cents / 4);
        var tamaraAmount = Math.round(variant.price_cents / 3);
        var sentence = 'Price ' + money(variant.price_cents, moneyFormat);

        if (tabby) tabby.textContent = '4 payments of ' + money(tabbyAmount, moneyFormat);
        if (tamara) tamara.textContent = '3 payments of ' + money(tamaraAmount, moneyFormat);

        if (variant.compare_cents && variant.compare_cents > variant.price_cents) {
          sentence += ', was ' + money(variant.compare_cents, moneyFormat);
        }
        sentence += '. Tabby 4 payments of ' + money(tabbyAmount, moneyFormat);
        sentence += '. Tamara 3 payments of ' + money(tamaraAmount, moneyFormat) + '.';
        if (announcement) announcement.textContent = sentence;
      }

      function updateAll() {
        currentVariant = resolve(state.size, state.firmness);
        if (!currentVariant) return;

        if (masterId) masterId.value = currentVariant.id;
        if (sizeValue) sizeValue.textContent = state.size;
        rebuildPrices(sizePrices, currentVariant);
        updatePriceLine(currentVariant);
        updateAtcTotal(currentVariant);
        updatePayments(currentVariant);
        updateSizeOptions();
        updateFirmnessOptions();
        if (atc) atc.disabled = inFlight || !currentVariant.available;
      }

      function closeList(focusTrigger) {
        if (!sizeList || !sizeTrigger) return;
        sizeList.hidden = true;
        sizeTrigger.setAttribute('aria-expanded', 'false');
        if (focusTrigger) sizeTrigger.focus();
      }

      function focusOption(option) {
        if (!option) return;
        Array.prototype.forEach.call(sizeOptions, function (item) {
          item.setAttribute('tabindex', item === option ? '0' : '-1');
        });
        option.focus();
      }

      function openList() {
        var selected;
        if (!sizeList || !sizeTrigger) return;
        sizeList.hidden = false;
        sizeTrigger.setAttribute('aria-expanded', 'true');
        selected = sizeList.querySelector('[data-buybox-size-option][aria-selected="true"]') || sizeOptions[0];
        focusOption(selected);
      }

      function selectSizeOption(option) {
        if (!option || option.getAttribute('aria-disabled') === 'true') return;
        state.size = option.getAttribute('data-value');
        updateAll();
        closeList(true);
      }

      function availableSizeOptions() {
        var available = [];
        Array.prototype.forEach.call(sizeOptions, function (option) {
          if (option.getAttribute('aria-disabled') !== 'true') available.push(option);
        });
        return available;
      }

      function moveOptionFocus(direction) {
        var available = availableSizeOptions();
        var activeIndex = available.indexOf(document.activeElement);
        var nextIndex;

        if (!available.length) return;
        if (activeIndex < 0) {
          nextIndex = direction > 0 ? 0 : available.length - 1;
        } else {
          nextIndex = (activeIndex + direction + available.length) % available.length;
        }
        focusOption(available[nextIndex]);
      }

      function showError(message) {
        var banner;
        if (!form || !form.parentNode) return;
        if (errorTimer) window.clearTimeout(errorTimer);

        banner = box.querySelector('.buybox-error');
        if (!banner) {
          banner = document.createElement('div');
          banner.className = 'buybox-error';
          banner.setAttribute('role', 'alert');
          banner.style.cssText = 'margin:12px 0;padding:12px 14px;border:1px solid #b3261e;background:#fdecec;color:#8f1d17;font-size:14px;';
          form.parentNode.insertBefore(banner, form.nextSibling);
        }
        banner.textContent = message;
        errorTimer = window.setTimeout(function () {
          if (banner.parentNode) banner.parentNode.removeChild(banner);
          errorTimer = null;
        }, 6000);
      }

      function restoreAtc(label, originalLabel) {
        inFlight = false;
        if (label) label.textContent = originalLabel;
        if (form) form.removeAttribute('aria-busy');
        if (atc) atc.disabled = !currentVariant || !currentVariant.available;
      }

      bindOnce(sizeTrigger, function (trigger) {
        trigger.addEventListener('click', function () {
          if (trigger.getAttribute('aria-expanded') === 'true') closeList(false);
          else openList();
        });
        trigger.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar' || event.key === 'ArrowDown') {
            event.preventDefault();
            openList();
          }
        });
      });

      bindOnce(sizeList, function (list) {
        list.addEventListener('click', function (event) {
          var option = event.target.closest && event.target.closest('[data-buybox-size-option]');
          if (!option || !list.contains(option)) return;
          event.preventDefault();
          selectSizeOption(option);
        });
        list.addEventListener('keydown', function (event) {
          var available;
          var option;
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            moveOptionFocus(event.key === 'ArrowDown' ? 1 : -1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            available = availableSizeOptions();
            option = event.key === 'Home' ? available[0] : available[available.length - 1];
            focusOption(option);
          } else if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            event.preventDefault();
            selectSizeOption(document.activeElement);
          } else if (event.key === 'Escape') {
            event.preventDefault();
            closeList(true);
          }
        });
        list.addEventListener('focusout', function () {
          window.setTimeout(function () {
            if (!sizeGroup.contains(document.activeElement)) closeList(false);
          }, 0);
        });
      });

      Array.prototype.forEach.call(firmnessOptions, function (radio) {
        bindOnce(radio, function (input) {
          input.addEventListener('change', function () {
            if (!input.checked) return;
            state.firmness = input.value;
            updateAll();
          });
        });
      });

      bindOnce(nativeSize, function (select) {
        select.addEventListener('change', function () {
          state.size = select.value;
          updateAll();
        });
      });

      bindOnce(bundleToggle, function (toggle) {
        toggle.addEventListener('change', function () {
          if (currentVariant) updateAtcTotal(currentVariant);
        });
      });

      bindOnce(form, function (productForm) {
        productForm.addEventListener('submit', function (event) {
          var label;
          var originalLabel;
          var items;

          event.preventDefault();
          event.stopImmediatePropagation();
          if (inFlight) return;

          currentVariant = resolve(state.size, state.firmness);
          if (!currentVariant || !currentVariant.available) return;

          inFlight = true;
          label = atc ? atc.querySelector('span:not([data-buybox-atc-total])') : null;
          originalLabel = label ? label.textContent : '';
          if (label) label.textContent = 'Adding\u2026';
          if (atc) atc.disabled = true;
          productForm.setAttribute('aria-busy', 'true');

          items = [{ id: currentVariant.id, quantity: 1 }];
          if (bundleToggle && bundleToggle.checked) {
            Array.prototype.forEach.call(box.querySelectorAll('[data-bundle-variant-id]'), function (tile) {
              var id = parseInt(tile.getAttribute('data-bundle-variant-id'), 10);
              if (id > 0) items.push({ id: id, quantity: 1 });
            });
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (response) {
            return response.json().then(function (body) {
              return { ok: response.ok, body: body };
            }, function () {
              return { ok: response.ok, body: null };
            });
          }).then(function (result) {
            var message;
            if (result.ok) {
              // Audit D1 (28 Sep 2026): stay on the page and show the cart panel (falls back to /cart).
              if (window.huxCartPanel) { restoreAtc(label, originalLabel); window.huxCartPanel.open(result.body); return; }
              window.location.href = '/cart';
              return;
            }
            message = result.body && (result.body.description || result.body.message);
            restoreAtc(label, originalLabel);
            showError(message || "Couldn't add to cart \u2014 please try again.");
          }).catch(function () {
            restoreAtc(label, originalLabel);
            showError("Couldn't add to cart \u2014 please try again.");
          });
        }, true);
      });

      bindOnce(document.body, function (body) {
        body.addEventListener('click', function (event) {
          var groups = body.querySelectorAll('[data-buybox-size]');
          Array.prototype.forEach.call(groups, function (group) {
            var trigger;
            var list;
            if (group.contains(event.target)) return;
            trigger = group.querySelector('[data-buybox-size-trigger]');
            list = group.querySelector('[data-buybox-size-list]');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
            if (list) list.hidden = true;
          });
        });
      });

      updateAll();
    });
  }

  function init(scope) {
    var root = scope && typeof scope.querySelectorAll === 'function' ? scope : document;
    initReveals(root);
    initStandardToggles(root);
    initCollectionChips(root);
    initJournalCopy(root);
    initJournalToc(root);
    initBuybox(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor re-renders sections; re-init the freshly rendered subtree.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
